<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">{{ tableData[0].name }}</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body"  style="max-height: 300px;padding: 10px;">
        <div v-for="(value,i) in tableData" :key="i" style="padding: 10px">
          <div style="float: left;width:100%;" v-for="(value,i) in value.arr" :key="i">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px;font-size: 15px">{{ value.name }}</div>
                <ve-pie :data="{columns: ['name', 'count'],rows: value.arr}"
                        :settings="{offsetY:110,radius:50}" :tooltip="{}"></ve-pie>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!--      <div class="modal-footer">-->
      <!--        <el-button @click.native="closeSelf">取消</el-button>-->
      <!--        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>-->
      <!--      </div>-->
    </div>
  </div>
</template>


<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      tableData:[]
    }
  },
  methods: {
    init(askAnswerRecordCode){

      this.getTotal(askAnswerRecordCode);

    },
    closeSelf() {
      this.$emit("closeAllCharts");
    },

    getTotal(code){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'AskAnswerRecordSite/Total',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          askAnswerRecordCode: code,
        }

      }).then( (response)=> {
        if(response.data.error == 0){

          this.tableData = response.data.data.arr;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>


